module.exports = __webpack_public_path__ + "components/wind-icon/static/S@2x-a8051f4d38ef0158fe99dd2241ec6d83.png";